// extracted by mini-css-extract-plugin
export default {"phone-dropdown":"styles_phone-dropdown__N6RFT","no-space-for-error":"styles_no-space-for-error__o8T5O","phone-dropdown-codes":"styles_phone-dropdown-codes__Q0Dw8"};